import { useState } from 'react'

export default function PortfolioBillboard() {
  const [open, setOpen] = useState(true)

  return (
    <div
      className="grid w-full transition-[grid-template-rows] duration-200 ease-[cubic-bezier(0.22,1,0.36,1)]"
      style={{ gridTemplateRows: open ? '1fr' : '0fr' }}
    >
      <div className="min-h-0 overflow-hidden">
        <div className="relative w-full px-1 pt-1 pb-0 transition-[padding] duration-200 ease-[cubic-bezier(0.22,1,0.36,1)]">
          <div
            className="relative overflow-hidden rounded-modal"
            style={{
              height: 32,
              background: 'var(--billboard-window)',
              boxShadow: 'var(--billboard-ring)',
            }}
          >
            <div
              className="flex h-full shrink-0 items-center justify-center overflow-hidden rounded-modal px-2.5"
              style={{ background: 'var(--billboard-tone-primary)' }}
            >
              <div className="flex w-full items-center justify-between gap-2">
                <span className="flex min-h-6 flex-1 items-center justify-center gap-2 text-center">
                  <span
                    data-icon="true"
                    className="flex size-4 shrink-0 items-center justify-center text-billboard-ink/70"
                  >
                    <svg
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="size-full"
                    >
                      <path
                        d="M6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5Z"
                        stroke="currentColor"
                        strokeOpacity="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5.625 5.625C5.72446 5.625 5.81984 5.66451 5.89016 5.73484C5.96049 5.80516 6 5.90054 6 6V7.875C6 7.97446 6.03951 8.06984 6.10983 8.14017C6.18016 8.21049 6.27554 8.25 6.375 8.25"
                        stroke="currentColor"
                        strokeOpacity="0.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5.8125 4.5C6.12316 4.5 6.375 4.24816 6.375 3.9375C6.375 3.62684 6.12316 3.375 5.8125 3.375C5.50184 3.375 5.25 3.62684 5.25 3.9375C5.25 4.24816 5.50184 4.5 5.8125 4.5Z"
                        fill="currentColor"
                        fillOpacity="0.5"
                      />
                    </svg>
                  </span>
                  <span
                    data-billboard-text="true"
                    className="text-sm/4 text-billboard-ink [&_a]:text-inherit [&_a]:underline"
                  >
                    <span className="flex items-center justify-center gap-2">
                      <img
                        alt=""
                        className="h-4 shrink-0"
                        width="86"
                        height="16"
                        src="/assets/svg/funkit-banner-Bnj6zNCz.svg"
                      />
                      <span>
                        Deposits from Card, Bitcoin, Coinbase, Tron, Solana,
                        USDT and more, are now available.
                      </span>
                    </span>
                  </span>
                </span>
                <button
                  className="inline-flex shrink-0 items-center justify-center gap-2 pl-2 text-sm/sm font-medium text-billboard-ink/60 transition-colors hover:opacity-80 hover:text-billboard-ink active:opacity-60"
                  type="button"
                  aria-label="Dismiss announcement"
                  onClick={() => setOpen(false)}
                >
                  <span
                    data-icon="true"
                    className="flex size-4 shrink-0 items-center justify-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 256 256"
                      fill="currentColor"
                      className="size-full"
                    >
                      <path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z" />
                    </svg>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
